import axiosInstanceClient from '../Common/Axios/axiosInstanceClient';
import API from '../Common/Endpoint/serviceConstrants';
export const callDealCouponFreqGetApi = async (payload) => {
  const { data = {} } = await axiosInstanceClient.get(API.dealcouponfrequency);
  return data;
};